<template>
    <div v-if="advertisement != null" style="position: absolute; height: 100%; width: 100%; z-index:999999; background-color: rgba(0, 0, 0, 0.5);" class="d-flex justify-content-between align-items-center">
        <div class="circle">
            <label style="margin-left: 9px" v-if='isCount'>{{count}}</label>
            <a href="#"  @click="onClose" style="margin-left: 9px; color: white !important" v-else>X</a>
        </div>
        <img :src="advertisement.path" alt="Publicidad"/>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: "Loading",
    props: ['isLoading'],
    data() {
        return {
            count: 5,
            isCount: true,
            showToday: true,
            advertisement: null
        }
    },
    methods: {
        onClose() {
            this.showToday = false;
        }
    },
    mounted() {
        let self = this;
        axios.get(`advertisement`)
            .then(response => {
                if (response.data) {
                    if (Object.keys(response.data).length !== 0) {
                        this.advertisement = response.data;
                        this.showToday = false;
                    }
                }
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>

<style scoped>
img {
    display: block;
    margin: auto;
    width: 50%;
}

.circle {
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    position: absolute;
    background: #cc9933;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    border-radius: 50px;
    font-weight: bold;
    font-size: 20px;
    color: white !important;
}
</style>
